import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { get } from 'lodash';

/* Actions  */
import { getConfig as getCompareConfig } from '@store/comparison/config/actions';

/* Selectors */
import { selectors as tabsStoreSelector } from '@store/dashboards/tabs';

/* Components  */
import AppSessionTimeline from '../app-session-timeline';
interface IProps {
  id: string;
  viewerId: string;
  tabs: any;
  getConfig: any;
  clientId: string;
  interval: string;
}
const TimelineWrapper: React.FC<IProps> = function TimelineWrapper({
  id,
  tabs,
  viewerId,
  getConfig,
  clientId,
  interval,
}) {
  const tabData = get(tabs, `tabsData.${id}`, null);
  useEffect(() => {
    const tData = tabData || get(tabs, `tabsData.${id}`, null);
    if (!tData && !viewerId && id && !clientId) {
      getConfig(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabData, id]);
  return (
    <AppSessionTimeline
      id={id}
      viewerId={viewerId || tabData?.config?.viewerId}
      clientId={clientId}
      interval={interval}
    />
  );
};

const selector = createSelector(tabsStoreSelector, (tabsStore) => ({
  tabs: tabsStore,
}));

export default connect(selector, {
  getConfig: getCompareConfig,
})(TimelineWrapper);
